export const actionKey = '@@NETWORKBAR';
export const reduxKey = '@@NETWORKBAR';
export const watchedGroupsStreamId = 'NETWORKBAR_WATCHED_GROUPS';
export const recommendedGroupsStreamId = 'NETWORKBAR_RECOMMENDED_GROUPS';
export const grouphubId = 63289494;
export const NETWORKBAR_FEEDBACK_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdkyYiYGzr35W_LehINmm-cFCFyijUsGsN-5W3ROazazCQ4dQ/viewform?usp=sf_link';
